// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"59f3f02a","238":"ecf2fdf0","456":"4eb664fc","561":"22dc3f2e","787":"856d341b","851":"b4a84ccb","921":"319d3423","988":"e642c43b"}[chunkId] + ".chunk.js";
};